import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { Drawer, drawerType } from '../../../../../packages/ui/organisms/drawer';
import { Checkbox } from '../../../../../packages/ui/atoms/checkbox';
import { FormControlLabel } from '../../../../../packages/ui/atoms/form-control-label';
import { TextError } from '../../../../../packages/ui/atoms/typography';

import { EducationExperienceSections } from '../../index.constants';
import { useStyles } from './Credentials.styles';

const Credentials = ({ title, isOpen, items, type, onClose, error, selectedItems, onUpdate }) => {
  const classes = useStyles();
  const [newItems, setNewItems] = useState(selectedItems || []);

  const [savingButton, setSavingButton] = useState(false);

  const onUpdateButtonClick = () => {
    setSavingButton(true);
  };

  useEffect(() => {
    if (!isOpen) {
      setSavingButton(false);
    }
  }, [isOpen]);

  useEffect(() => {
    setNewItems(selectedItems || []);
  }, [selectedItems]);

  const onChange = value => () => {
    const newSelectedCredentials = newItems.includes(value)
      ? newItems.filter(item => item !== value)
      : [...newItems, value];
    setNewItems(newSelectedCredentials);
  };

  const handleSubmit = () => {
    const key = type === EducationExperienceSections.CERTIFICATIONS ? 'certifications' : 'credentials';
    onUpdate({ [key]: newItems });
  };

  return (
    <Drawer
      title={title}
      open={isOpen}
      onClose={onClose}
      variant={drawerType.FORM}
      submitBtnTitle={savingButton ? 'Saving' : 'Update'}
      disableSubmit={savingButton}
      onSubmit={() => {
        onUpdateButtonClick();
        handleSubmit();
      }}
    >
      <Box className={classes.drawerContent}>
        {error && (
          <Box display="flex" justifyContent="center" paddingY={1}>
            <TextError errorMsg={error} />
          </Box>
        )}
        {items.map(item => (
          <FormControlLabel
            key={item.value}
            control={<Checkbox checked={newItems.includes(item.value)} />}
            onChange={onChange(item.value)}
            label={item.label}
          />
        ))}
      </Box>
    </Drawer>
  );
};

export { Credentials };
